import React, { useRef, useState, useEffect,forwardRef } from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import '../../css/export.css';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
import Box from '@material-ui/core/Box';
import { DatePicker, MuiPickersUtilsProvider,KeyboardDatePicker } from "@material-ui/pickers";
import Button from '@material-ui/core/Button';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import format from "date-fns/format";
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { setCookie, clearCookie, getPrivileges } from '../../functions/Auth';
import '../../scss/components/_exportData.scss';
import ErrorMessage from '../AppLayouts/ErrorMessage';
const API_URL = process.env.REACT_APP_BASE_URL;
const axios = require('axios');
const AWS = require('aws-sdk');

  let table_data=[]
  let stationAllArray=[]
  let stationAllArrayTemp=[]
  let prevStartDate = null;
  let prevEndDate = null;
  let maxFromDB = 25;
  let totalSelected = 25;
  let totalDates = 0;
//
const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
      
        container: {
            maxHeight: 440,
        },
    },
});

function Row(props) {
    const { row ,selectMidblockDataAll,getMidblockDatesData,getCheckHtml,checkHeaderCheckBoxes,
            selectIntersectionData,getIntersectionDatesData,checkIntersectionBoxes,
            indrow, selectAllByRow,selectedRows,selectAll,individualSelDate,mostRecentChecked,mostRecentDate, selectedPartialRows
        } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
   
    return (
        
        row.data.length > 0 &&
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell style={{ width: '48px' }} className={indrow % 2 === 1 ? "zebra" : ""}>
                        <div className={'horizontal-center'}>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                        </IconButton>
                        </div> 
                    
                    </TableCell>
                    <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: '48px'}} className={indrow % 2 === 1 ? "zebra" : ""}>
                            <StyledCheckbox 
                                checked={ (selectedRows.indexOf(row.station_id) >= 0 ) } 
                                id={'all-Checkbox-' +row.Station_location} 
                                onChange={(e) => selectAllByRow(e, indrow, row.station_id)} 
                                indeterminate={selectedPartialRows.indexOf(row.station_id) >= 0 && selectedRows.indexOf(row.station_id) < 0}
                            />  
                    </TableCell>
                    <TableCell component="th" scope="row" className={'font-default'} style={{ width: '350px'}} className={indrow % 2 === 1 ? "zebra" : ""}>
                        <div className={'padding_10_16'}> {row.Station_location}</div>
                    </TableCell>
                    <TableCell align="right" className={'font-default'} style={{ width: '250px' }} className={indrow % 2 === 1 ? "zebra" : ""}>
                        <div className={'padding_10_16'}> {row.station_id}</div>
                    </TableCell>
                    <TableCell align="right" className={'font-default'} style={{ width: '150px' }} className={indrow % 2 === 1 ? "zebra" : ""}> 
                        <div style={{display:'flex',alignItems:'center'}}  className={'padding_10_16'}> 
                            {row.station_type=='Midblock'?<img src={require('../../assets/icons/midblock_v1.png')}   />:<img src={require('../../assets/icons/intersection_v1.png')}   />}
                            <span className={'font-default'} style={{marginLeft:'4px'}}>{row.station_type}</span>
                        </div> 
                    </TableCell>
                </TableRow>
                <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box margin={1}  className={'subtable'}>
                    <div>
                            <Table size="small" aria-label="purchases">
                                <TableBody>
                                    {row.data.map((getDates,index) => (
                                        <>
                                        {getDates.station_type=='Midblock'?
                                                <StyledTableRow key={index} style={{height:'40px'}}>
                                                
                                                    <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: 48, background: '#FFFFFF' }} >
                                                        <StyledCheckbox     
                                                            checked={ (index===0 && mostRecentDate.includes(getDates.Station_id+"-"+getDates.mainDate) || 
                                                                        selectedRows.indexOf(getDates.Station_id) >= 0 || 
                                                                        individualSelDate.indexOf(getDates.Station_id+"-"+getDates.mainDate) >= 0)
                                                                    } 
                                                            name='all' value='all' 
                                                            className={classes.dataCheck} id={'all-' + getDates.Station_id + '-' + index} 
                                                            onChange={(e) => 
                                                                selectMidblockDataAll(e, 
                                                                    getDates.Station_id, getDates.station_type, getDates.mainDate, 
                                                                    getDates.consecutive_flag, getDates.consecutive_status, index, 
                                                                    getDates.volume, getDates.class, getDates.speed)
                                                            } 
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" className={'font-default'} style={{ width: 380,background: '#FFFFFF' }} > 
                                                        {getDates.date}
                                                    </TableCell>
                                                    <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: 100,background: '#FFFFFF' }} >
                                                        {getDates.volume == true ?
                                                            <div className={'vertical-center'}><img src={require('../../assets/icons/study/Chart - Bar.png')}   /></div>
                                                            : null}
                                                    </TableCell>
                                                    <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: 100 ,background: '#FFFFFF'}} >
                                                        {getDates.class == true ?
                                                            <div className={'vertical-center'}><img src={require('../../assets/icons/study/Truck.png')}   /></div>
                                                            :null}
                                                    </TableCell>
                                                    <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: 100 ,background: '#FFFFFF'}} >
                                                        {getDates.speed == true ?
                                                            <div className={'vertical-center'}><img src={require('../../assets/icons/study/Speedo.png')}   /></div>
                                                            :
                                                            null}
                                                        {index === getMidblockDatesData.length - 1 && getCheckHtml === 1 ? checkHeaderCheckBoxes(getDates.Station_id) : null}

                                                    </TableCell>
                                                </StyledTableRow>
                                        :
                                            <StyledTableRow key={index}  style={{height:'40px'}}>
                                                <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: '40px',background: '#FFFFFF'  }}>
                                                    <StyledCheckbox 
                                                        checked={ (index===0 && mostRecentDate.includes(getDates.Station_id+"-"+getDates.mainDate) || 
                                                            selectedRows.indexOf(getDates.Station_id) >= 0 || 
                                                            individualSelDate.indexOf(getDates.Station_id+"-"+getDates.mainDate) >= 0)}  
                                                        name='interSection' 
                                                        value='interSection' 
                                                        className={classes.dataCheck} 
                                                        id={'interSection-' + getDates.Station_id + '-' + index} 
                                                        onChange={(e) => selectIntersectionData(e, getDates.Station_id, getDates.station_type, getDates.mainDate)} />
                                                </TableCell>
                                                <TableCell align="right" className={'font-default'} style={{ width: 380,background: '#FFFFFF' }}>
                                                    {getDates.date}
                                                </TableCell>
                                                <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: 100,background: '#FFFFFF' }}>
                                                    {getDates.turning == true ?
                                                    <div className={'vertical-center'}><img src={require('../../assets/icons/study/Turning Movement.png')}   /></div>
                                                        : null}
                                                </TableCell>
                                                <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: 100,background: '#FFFFFF' }}>
                                                    {getDates.pedestrian == true ?
                                                    <div className={'vertical-center'}><img src={require('../../assets/icons/study/Walking.png')}   /></div>
                                                        :null}
                                                </TableCell>
                                                <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: 100,background: '#FFFFFF' }}>
                                                    {getDates.bicycle == true ?
                                                    <div className={'vertical-center'}><img src={require('../../assets/icons/study/Bike.png')}   /></div>
                                                        :null}
                                                    {index === getIntersectionDatesData.length - 1 ? checkIntersectionBoxes() : null}
                                                </TableCell>
                                            </StyledTableRow>
                                        }
                                    </>
                                    ))}
                                </TableBody>
                            </Table>
                    </div>
                    </Box>
                    </Collapse>
                </TableCell>
                </TableRow>
            </React.Fragment>
        
    );
}

//Start Css code ...
const useStyles = makeStyles((theme) => ({
    ExternalMainBlock: {
        width: '100%',
        zIndex: '111',
        float: 'left',
        position: 'absolute',
        top: '0px',
        background: 'rgba(0,0,0,.5)',
        left: '0',
        display:'flex',
        alignItems: 'center'
        
    },
  
    myCheckBox: {
        '@media only screen and (max-width: 3500px)': {
            padding: 0,
        },
        '@media only screen and (min-width: 3501px)': {
            padding: 0,
            '& svg': {
                fontSize: '26pt',
                marginLeft: '-5px',
            }
        },
    },
    tickIcon: {
        margin: '0',
        textAlign: 'center',
    },
    checkedIcom: {
        color: '#006600',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '15pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    crossIcom: {
        color: '#CC0000',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '15pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    dataTDCheckBox: {
        textAlign: 'center !important',
        paddingLeft: '5px !important',
        paddingRight: '5px !important',
    },
    intervalOptionBlock: {
        width: '50%',
        float: 'left',
        margin: '0',
        '& label span': {
            '@media only screen and (max-width: 3500px)': {
                fontSize: '14pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt',
                '& svg': {
                    fontSize: '26pt',
                    marginTop: '-5px',
                }
            },
        },
        '@media only screen and (min-width: 3501px)': {
            '& svg': {
                fontSize: '26pt',
                marginTop: '-5px',
            }
        },
    },
    headIcon: {
        color: '#333'
    },
    headIconBox: {
        textAlign: 'center !important',
    },
    consiInd: {
        float: 'left',
        background: '#24618E',
        marginLeft: '-5px',
        marginTop: '-14px',
        marginRight: '5px',
        position: 'relative',
        bottom: '-9px',
        '@media only screen and (max-width: 3500px)': {
            height: '36px',
            width: '7px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '54px',
            width: '10px',
        },
    },
    consiAlt: {
        width: '7px',
        float: 'left',
        background: '#00A75D',
        marginLeft: '-5px',
        marginTop: '-14px',
        marginRight: '5px',
        position: 'relative',
        bottom: '-9px',
        '@media only screen and (max-width: 3500px)': {
            height: '36px',
            width: '7px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '54px',
            width: '10px',
        },
    },
    consiGap: {
        width: '7px',
        float: 'left',
        background: '#fff',
        marginLeft: '-5px',
        marginTop: '-14px',
        marginRight: '5px',
        position: 'relative',
        bottom: '-9px',
        '@media only screen and (max-width: 3500px)': {
            height: '36px',
            width: '7px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '54px',
            width: '10px',
        },
    },
    dataBlock: {
        width: '100%',
    },
    exportBlock: {
        width: '100%',
        '& .MuiCheckbox-root': {
            padding: 0,
            paddingLeft: '10px',
            paddingRight: '3px',
        },
        '@media only screen and (min-width: 3501px)': {
            '& svg': {
                fontSize: '26pt',
                marginTop: '-5px',
            }
        },
    },
    stationCount: {
        margin: '10px 0px 5px 15px',
    },
    optionBock: {
        width: '100%',
        '& h4': {
            color: '#333',
            margin: '5px 0',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '14pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt',
            },
        },
        '& hr': {
            marginTop: '35px !important',
            marginBottom: '30px',
            width: '75%',
        }
    },
    dataCheck: {
        height: '5px',
        width: '5px',
        verticalAlign: 'middle',
    },
    outerCheck: {
        display: 'block',
        position: 'relative',
        paddingLeft: '0px',
        marginBottom: '0px',
        cursor: 'pointer',
        fontSize: '15px',
        '& input': {
            visibility: 'hidden',
            cursor: 'pointer',
        },
        '& .mark': {
            position: 'absolute',
            top: '2px',
            backgroundColor: '#fff',
            border: '2px solid #888',
            borderRadius: '2px',
            '@media only screen and (max-width: 3500px)': {
                height: '18px',
                width: '18px',
                left: '5px',
            },
            '@media only screen and (min-width: 3501px)': {
                height: '25px',
                width: '25px',
                left: '13px',
            },
        },
        '&:hover input ~ .mark': {
            backgroundColor: '#fff',
        },
        '& input:checked ~ .mark': {
            backgroundColor: 'blue',
            border: '1px solid blue',
        },
        '& .mark:after': {
            content: "",
            position: 'absolute',
            display: 'none',
        },
        '& input:checked ~ .mark:after': {
            display: 'block',
        },
        '& .mark:after': {
            top: '0px',
            border: 'solid #fff',
            transform: 'rotate(45deg)',
            borderWidth: '0 2px 2px 0',
            '@media only screen and (max-width: 3500px)': {
                left: '5px',
                width: '6px',
                height: '14px',
            },
            '@media only screen and (min-width: 3501px)': {
                left: '7px',
                width: '10px',
                height: '18px',
            },
        }
    },
    selectedError: {
        background: '#F2DEDE',
        border: '1px solid #CC0000',
        padding: '5px',
        color: '#333',
        borderRadius: '5px',
        marginBottom: '0px',
        marginTop: '10px',
        '& svg': {
            verticalAlign: 'top',
            marginRight: '5px',
            color: '#CC0000',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '16pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '26pt',
            },
        }
    },
    dataloader: {
        width: '25px !important',
        height: '25px !important',
        color: '#fff !important',
        verticalAlign: 'middle',
    },
    loadingDiv: {
        width: '100%',
        background: 'rgba(0,0,0,.5)',
        position: 'absolute',
        height: '100%',
        zIndex: '999',
        marginTop: '-10px',
        marginLeft: '-10px',
        textAlign: 'center',
    },
    dataExportloader: {
        width: '70px !important',
        height: '70px !important',
        marginTop: '65px',
        '& svg': {
            color: '#fff',
        }
    },
    exportConsiCheckBox: {
        '@media only screen and (max-width: 3500px)': {
            marginLeft: '15px',
            fontSize: '14pt'
        },
        '@media only screen and (min-width: 3501px)': {
            marginLeft: '35px',
            fontSize: '24pt'
        },
    },
    tableIntersection: {
        '& .mark': {
            '@media only screen and (min-width: 3501px)': {
                left: '0 !important',
                top: '-5px',
            },
        }
    },
    tableMid: {

    },
    loaderDiv: {
        width: '100%',
        float: 'left',
        textAlign: 'center',
        '@media only screen and (max-width: 3500px)': {
            '& img': {
                height: '80px',
                width: '80px',
                marginTop: '70px'
            },
            '& p': {
                margin: '0px',
                marginTop: '25px',
                color: '#24618E',
                fontSize: '16pt'
            }
        },
        '@media only screen and (min-width: 3501px)': {
            '& img': {
                height: '150px',
                width: '150px',
                marginTop: '150px'
            },
            '& p': {
                margin: '0px',
                marginTop: '50px',
                color: '#24618E',
                fontSize: '26pt'
            }
        },
    },
    rootChk: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#ffffff',
        '$root.Mui-focusVisible &': {
          outline: '2px auto rgba(19,124,189,.6)',
          outlineOffset: 2,
        },
        'input:hover ~ &': {
          backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
          boxShadow: 'none',
          background: 'rgba(206,217,224,.5)',
        },
      },
      checkedIcon: {
        backgroundColor: '#2563EB',
        boxShadow: 'none',
        '&:before': {
          display: 'block',
          width: 16,
          height: 16,
          backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
          content: '""',
        },
        'input:hover ~ &': {
          backgroundColor: '#2563EB',
        },
    },
}));
//End Css code ...

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

let stationTypeData;
let intervalOptionFirst = '15-minute intervals';
let intervalOptionSecond = '5-minute intervals';
let stationCount;
let StationIdGroup;

function StyledCheckbox(props) {
    const classes = useStyles();
  
    return (
      <Checkbox
        className={classes.rootC}
        disableRipple
        color="default"
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        icon={<span className={classes.icon} />}
        inputProps={{ 'aria-label': 'decorative checkbox' }}
        {...props}
      />
    );
}

//Start ExportData component code ...
const ExportData = props => {
    const classes = useStyles();

    const [exportAsSingleFile, setExportAsSingleFile] = useState(false);

    const [backPageBtn, setBackPageBtn] = useState('none');
    const [nextPageBtn, setNextPageBtn] = useState('inline-block');
    const [counter, setCounter] = useState(0);
    const [data, setData] = useState([]);
    const [exportFormatBlock, setExportFormatBlock] = useState('none');
    const [optionStatus, setOptionStatus] = useState('none');
    const [stationDataBlock, setStationDataBlock] = useState('inline-block');
    const [stationTypeName, setStationTypeName] = useState();
    const [getIntersectionDatesData, setIntersectionDatesData] = useState([]);
    const [getMidblockDatesData, setMidblockDatesData] = useState([]);
    const [getExportRequest, setExportRequest] = useState([]);
    const [intersectionInterval, setIntersectionInterval] = useState('15');
    const [midblockInterval, setMidblockInterval] = useState('60');
    const [intersectionStatus, setIntersectionStatus] = useState(0);
    const [midblockStatus, setMidblockStatus] = useState(0);
    const [consiCutiveStatus, setConsiCutiveStatus] = useState(0);
    const [optionSeparately, setOptionSeparately] = useState(true);
    const [optionCombined, setOptionCombined] = useState(true);
    const [loderStatus, setLoderStatus] = useState(0);
    const [noDataText, setNoDataText] = useState('');
    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');
    const [allCheckValue, setAllCheckValue] = React.useState(0);
    const [errorDisplay, setErrorDisplay] = React.useState('none');
    const [midVolValue, setMidVolValue] = React.useState(0);
    const [midClassValue, setMidClassValue] = React.useState(0);
    const [midSpeedValue, setMidSpeedValue] = React.useState(0);
    const [exportFailedError, setExportFailedError] = React.useState('');
    const [getConsiChecked, setConsiChecked] = React.useState(false);
    const [getCheckEvent, setCheckEvent] = React.useState(false);
    const [getErrorHtml, setErrorHtml] = React.useState(false);
    const [preConsiCheck, setPreConsiCheck] = React.useState([]);
    const [exportStatus, setExportStatus] = React.useState(false);
    const [getCheckHtml, setCheckHtml] = React.useState(0);
    const [stationId, setStationId] = useState(null);
    const [startDatePicker, setStartDatePicker] = React.useState(null);
    const [endDatePicker, setEndDatePicker] = React.useState(null);
    const [isOpenTo, setIsOpenTo] = React.useState(false);
    const [isOpenFrom, setIsOpenFrom] = React.useState(false);

    const [steep1, setSteep1] = React.useState(true);
    const [steep2, setSteep2] = React.useState(false);
    const [steep3, setSteep3] = React.useState(false);
    const [showErrorSteep1, setShowErrorSteep1] = React.useState(false);
    const [showMidblock, setShowMidblock] = React.useState(false);
    const [showIntersection, setShowIntersection] = React.useState(false);
    
      const [volume_count, setVolume_Count] = React.useState(false);
      const [traffic_speed, setTraffic_Speed] = React.useState(false);
      const [turning_count, setTurning_Count] = React.useState(false);
      const [pedestrian_count, setPedestrian_Count] = React.useState(false);
      const [bicycle_count, setBicycle_Count] = React.useState(false);
      const [vehicle_class, setVehicle_Class] = React.useState(false);

      const [getSelectedStartDate, setSelectedStartDate] = React.useState(new Date());
      const [getSelectedEndDate, setSelectedEndDate] = React.useState(new Date());

      const [totalMid, setTotalMid] = React.useState(0);
      const [totalInt, setTotalInt] = React.useState(0);
      const [mostRecentChecked, setMostRecentChecked] = React.useState(false);
      const [mostRecentDate, setMostRecentDate] = React.useState([]);
        const [selectedRows, setSelectedRows] = React.useState([]);
        const [selectedPartialRows, setSelectedPartialRows] = React.useState([]);
        const [selectAll, setSelectAll] = React.useState(false);
        const [individualSelDate, setIndividualSelDate] = React.useState([]);
        const [errPopUp, setErrPopUp] = React.useState(false);
        const [errMsg, setErrMsg] = React.useState(null);
        const [errMsgType, setErrMsgType] = React.useState('error');
        const [msgTitle, setMsgTitle] = useState(null);

      const initialFilter={
        volume:false,
        class:false,
        speed:false,
        turn:false,
        pedestrian:false,
        bicycle:false,
        startDate:"",
        endDate:""
    
      }
      
      const [ filter, setFilter]= useState(initialFilter)
      const [ filterisactive, setFilterisactive]= useState(false)
      
      const [csvExport, setCsvExport] = React.useState(false);
      const [pdfExport, setPdfExport] = React.useState(false);
      const [loadingInfo, setLoadingInfo] = useState(false);
      const [scrolled, setScrolled] = useState(false);
      const [checkedAll, setCheckedAll] = useState(false);
        const tableBodyRef = useRef();
        let history = useHistory();


    const updateMainFilter =(key,value) => {
      
      setFilter({...filter,
                [key]:value}) 
    }
    const updateFilterisactive =(value)=>{
      setFilterisactive(value)
    }

    class LocalizedUtils extends DateFnsUtils {
        getDatePickerHeaderText(date) {
          return format(date, "YYYY-MM-DD");
        }
    }

    useEffect(
        () => {
            getAswToken();
            stationAllArray=[]
            stationAllArrayTemp=[]
            callExportData();
            setSelectAll(false);
            stationCount = 1;
            getDaysLimit();
            totalDates = 0;
            setMostRecentDate([]);
        }, []
    );

    useEffect(
        () => {
            if(filterisactive){
                filterTable()
            }
        }, [{filter}]
    );

    const getDaysLimit = () => {
        try {
          axios({
            method: 'get',
            url: API_URL + API_PATH.getExportFileLimit,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                if (response.data && response.data.data) {
                  let data = response.data.data;
                  data.forEach(function(item) {
                    if(item.type === "export_dates")
                        totalSelected = item.max;
                        maxFromDB = item.max;
                  })
                } 
              }
            }).catch(async function (error) {
              if (error.response) {
                if (error.response.status && error.response.status == '401') {
                  if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('atexpiry');
                  }
                  history.push('/');
                }
              }
            })
        } catch (error) {
          console.error(error);
        }
      }

  //This method is used for get all Export Data .... Start
    const callExportData = () => {
        let countMid = 0;
        let countInt = 0;
        if (props.groupStations && props.groupStations.length > 0) {
            StationIdGroup = props.groupStations;
            stationTypeData = StationIdGroup[0].station_type == 1 ? "Midblock" + '  ' + StationIdGroup[0].client_Station_Id + ' - ' + StationIdGroup[0].Station_location : "Intersection" + '  ' + StationIdGroup[0].client_Station_Id + ' - ' + StationIdGroup[0].Station_location;
            setData(StationIdGroup);
            table_data=StationIdGroup
            stationAllArray=[];
            stationAllArrayTemp=[];
            let justids = [];
            let justlocations = [];
            for (let i = 0; i < StationIdGroup.length; i++) {
                // getExportData(StationIdGroup[i].station_id, StationIdGroup[i].station_type,StationIdGroup[i]);
                if(StationIdGroup[i].station_type === 1) {
                    justids.push(StationIdGroup[i].station_id);
                    justlocations.push(StationIdGroup[i]);
                    countMid++;
                }
                else if (StationIdGroup[i].station_type === 2) {
                    justids.push(StationIdGroup[i].station_id);
                    justlocations.push(StationIdGroup[i]);
                    countInt++;
                }
            }

            getExportDatav2(justids, justlocations);

            setTotalInt(countInt);
            setTotalMid(countMid);
            setStationTypeName(StationIdGroup[0].station_type);
        }
        else {
            setStationTypeName('');
        }
    }
  //This method is used for get all Export Data .... End

    const getExportDatav2 = (stationsIds, locations) => {
        // setStationId(station_id);
        setMidblockDatesData([]);
        setIntersectionDatesData([]);
        setLoderStatus(0);
        setNoDataText('');
        setConsiCutiveStatus(0);
        setErrorHtml(false);
        setCheckEvent(false);
        setLoadingInfo(true);
        try {
            axios({
                method: 'post',
                timeout: 600000,
                data: {
                    stationIds: stationsIds,
                },
                url: API_URL + API_PATH.exportdatav2,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {
                    setLoadingInfo(false); 
                    if (response && response.status == '200') {
                        let stationTypeData = response.data.data;
                        if (stationTypeData.length > 0) {
                            await Promise.all(stationTypeData.map(async function(item, itemind) {
                                let interDataArray = [];
                                let loc = locations[itemind].Station_location;
                                if(Array.isArray(item)) {
                                    await setMidDataValue(item).then(async result => {
                                        if (result && result.midarray) {
                                            if (result.midarray.length > 0) {
                                                
                                                setMidblockDatesData(result.midarray);
                                                
                                                setConsiCutiveStatus(result.con_status);
                                                checkReturnConsiCheckValue(result.station_id);
                                                stationAllArray.push({
                                                    Station_location:loc,
                                                    station_id:result.station_id,
                                                    station_type:"Midblock",
                                                    con_status:result.con_status,
                                                    data:result.midarray,
                                                    data:result.midarray
                                                })
                                                stationAllArrayTemp.push({
                                                    Station_location:loc,
                                                    station_id:result.station_id,
                                                    station_type:"Midblock",
                                                    con_status:result.con_status,
                                                    data:result.midarray,
                                                    data2:result.midarray
                                                })
                                                totalDates += result.midarray.length;
                                            }
                                            setAllCheckBox(result.midarray).then(async result => {
                                                if (result.length > 0) {
                                                    setAllCheckValue(result);
                                                }
                                            }).catch(err => {
                                                console.log(err)
                                            })
        
                                            setNoDataText('');
                                            if (result.midarray.length > 0) {
                                                setMidblockStatus(1);
                                            }
                                        }
                                    }).catch(err => {
                                        console.log(err)
                                    })
                                } else {
                                    if (item.dates.length > 0) {
                                        totalDates += item.dates.length;
                                        for (let i = 0; i < item.dates.length; i++) {
                                            let mainDate = item.dates[i].date;
                                            let totalDate = item.dates[i].display_date;
                                            interDataArray.push({ Station_id: item.station_id, station_type: item.station_type, mainDate: mainDate, date: totalDate, day: getDayFromDate(totalDate), turning: item.dates[i].turning, pedestrian: item.dates[i].pedestrian, bicycle: item.dates[i].bicycle });
                                        }
                                        
                                        stationAllArray.push({
                                            Station_location:loc,
                                            station_id:item.station_id,
                                            station_type:"Intersection",
                                            data:interDataArray,
                                            data2:interDataArray
                                        })
                                        stationAllArrayTemp.push({
                                            Station_location:loc,
                                            station_id:item.station_id,
                                            station_type:"Intersection",
                                            data:interDataArray,
                                            data2:interDataArray
                                        })
        
                                        setIntersectionDatesData(interDataArray);
                                        setNoDataText('');
                                        if (interDataArray.length > 0) {
                                            setIntersectionStatus(1);
                                        }
                                    }
                                    else {
                                        setIntersectionDatesData([]);
                                        setNoDataText('No data has been imported for this station');
                                    }
                                }
                                return true;
                            }));
                            totalSelected = maxFromDB
                            // if(totalDates < maxFromDB) {
                            //     totalSelected = totalDates;
                            // } 
                        }
                        else {
                            setNoDataText('No data has been imported for this station');
                        }

                    } else {
                        setNoDataText('No data has been imported for this station');
                    }
                    setLoderStatus(1);
                })
                .catch((err) => {
                    setLoderStatus(1);
                    setNoDataText('Something went wrong ...!');
                })
        } catch (error) {
            console.error(error);
            setLoderStatus(1);
            setNoDataText('Something went wrong ...!');
        }
        setConsiChecked(false);
    }

    //This method is used for setting interval in midblock and intersection .... Start
    const pageData = (count) => {
        if (count == 0) {
            setBackPageBtn('none');
            setNextPageBtn('inline-block');
            intervalOptionFirst = '15-minute intervals';
            intervalOptionSecond = '5-minute intervals';
            setExportFormatBlock('none');
            setStationDataBlock('inline-block');
            setOptionStatus('none');
            setErrorDisplay('none');
        } else if (count < data.length) {
            setBackPageBtn('inline-block');
            setNextPageBtn('inline-block');
            intervalOptionFirst = '60-minute intervals';
            intervalOptionSecond = '15-minute intervals';
            setExportFormatBlock('none');
            setStationDataBlock('inline-block');
            setOptionStatus('none');
            setErrorDisplay('none');
        } else if (count == data.length) {
            setBackPageBtn('inline-block');
            setNextPageBtn('inline-block');
            setExportFormatBlock('none');
            setStationDataBlock('none')
            setOptionStatus('inline-block');
            setErrorDisplay('inline-block');
        }
        else {
            setBackPageBtn('inline-block');
            setNextPageBtn('inline-block');
            setErrorDisplay('none');
        }
    }
    //This method is used for setting interval in midblock and intersection .... End

    //This method is use for consi checkbox selection .... Start
    const checkReturnConsiCheckValue = (station_id) => {
        let indexCheck = preConsiCheck.findIndex((ele, index) => ele.station_id === station_id);
        if (indexCheck === -1) {
            setPreConsiCheck([...preConsiCheck, { station_id: station_id, status: true }]);
        }
        else {
            let newArr = [...preConsiCheck];
            newArr[indexCheck] = {
                station_id: preConsiCheck[indexCheck].station_id,
                status: preConsiCheck[indexCheck].status
            };
            setPreConsiCheck(newArr);
            setConsiChecked(preConsiCheck[indexCheck].status);
        }
    }
    //This method is use for consi checkbox selection .... Start

    const setMidDataValue = (stationTypeData) => {
        let midDataArray = [];
        let consiStatus = 0;
        let con_color = '';
        let stationID;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < stationTypeData.length; i++) {
                if (stationTypeData[i].consecutive_flag > 0 && stationTypeData[i].consecutive_status == true && (stationTypeData[i].consecutive_flag % 2 == 1)) {
                    con_color = 'green';
                    consiStatus = 1;
                }
                else if (stationTypeData[i].consecutive_flag > 0 && stationTypeData[i].consecutive_status == true && (stationTypeData[i].consecutive_flag % 2 == 0)) {
                    con_color = 'blue';
                    consiStatus = 1;
                }
                else {
                    con_color = 'white';
                }
                for (let j = 0; j < stationTypeData[i].dates.length; j++) {
                    let mainDate = stationTypeData[i].dates[j].date;
                    let totalDate = stationTypeData[i].dates[j].display_date;
                    midDataArray.push({ Station_id: stationTypeData[i].station_id, station_type: stationTypeData[i].station_type, mainDate: mainDate, date: totalDate, day: getDayFromDate(totalDate), volume: stationTypeData[i].dates[j].volume, class: stationTypeData[i].dates[j].class, speed: stationTypeData[i].dates[j].speed, con_color: con_color, consecutive_flag: stationTypeData[i].consecutive_flag, consecutive_status: stationTypeData[i].consecutive_status });
                    table_data.push({ station_id: stationTypeData[i].station_id, 
                                        station_type: stationTypeData[i].station_type, 
                                        mainDate: mainDate, 
                                        date: totalDate, 
                                        day: getDayFromDate(totalDate), 
                                        volume: stationTypeData[i].dates[j].volume, 
                                        class: stationTypeData[i].dates[j].class, 
                                        speed: stationTypeData[i].dates[j].speed, 
                                        con_color: con_color, 
                                        consecutive_flag: stationTypeData[i].consecutive_flag, 
                                        consecutive_status: stationTypeData[i].consecutive_status,
                                        parentId:stationTypeData[i].station_id })
                }
                stationID = stationTypeData[i].station_id;
            }
            let obj = {
                midarray: midDataArray,
                con_status: consiStatus,
                station_id: stationID,
            }
            resolve(obj)
        })
    }

    // This function is used for unselect header checkboxes checkboxes
    const unselectHeaderCheckBoxes = (station_id) => {
        if (document.getElementById('all-volume-' + station_id) !== null) {
            document.getElementById('all-volume-' + station_id).checked = false;
        }
        if (document.getElementById('all-class-' + station_id) !== null) {
            document.getElementById('all-class-' + station_id).checked = false;
        }
        if (document.getElementById('all-speed-' + station_id) !== null) {
            document.getElementById('all-speed-' + station_id).checked = false;

        }
        if (document.getElementById('all-Checkbox-' + station_id) !== null) {
            document.getElementById('all-Checkbox-' + station_id).checked = false;
        }
    }
    // This function is used for unselect header checkboxes checkboxes

    //Check Header Checkboxes method
    const checkHeaderCheckBoxes = (station_id) => {
        if (document.getElementById('all-volume-' + station_id) !== null) {
            setAllVolumeBox().then(async result => {
                setMidVolValue(result);
            }).catch(err => {
                console.log(err);
            });
        }
        if (document.getElementById('all-class-' + station_id) !== null) {
            setAllClassBox().then(async result => {
                setMidClassValue(result);
            }).catch(err => {
                console.log(err);
            });
        }
        if (document.getElementById('all-speed-' + station_id) !== null) {
            setAllSpeedBox().then(async result => {
                setMidSpeedValue(result);
            }).catch(err => {
                console.log(err);
            });
        }
        checkSelectedCheckBoxes();
    }
    //Check Header Checkboxes method

    const checkSelectedCheckValue = (checkedValue) => {
        let allVolumeValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < checkedValue.length; i++) {
                if (document.getElementById('all-' + checkedValue[i].Station_id + '-' + i)) {
                    if (!document.getElementById('all-' + checkedValue[i].Station_id + '-' + i).checked) {
                        allVolumeValue = 0;
                    }
                }
            }
            resolve(allVolumeValue);
        })
    }

    //This method is used for selected checkboxse show
    const checkSelectedCheckBoxes = () => {
        if (getExportRequest.length > 0) {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                if (indexExprot !== -1) {
                    if (getExportRequest[indexExprot].volume) {
                        if (document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                    else {
                        if (document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i).checked = false;
                        }
                    }
                    if (getExportRequest[indexExprot].class) {
                        if (document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                    else {
                        if (document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i).checked = false;
                        }
                    }
                    if (getExportRequest[indexExprot].speed) {
                        if (document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                    else {
                        if (document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i).checked = false;
                        }
                    }

                    if (getExportRequest[indexExprot].volume && getExportRequest[indexExprot].class && getExportRequest[indexExprot].speed) {
                        if (document.getElementById('all-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('all-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                }
            }

            checkSelectedCheckValue(getMidblockDatesData).then(async result => {
                if (result === 1) {
                    if (document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id) !== null) {
                        document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id).checked = true;
                    }
                }
                else {
                    if (document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id) !== null) {
                        document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id).checked = false;
                    }
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
    //This method is used for selected checkboxse show


    const checkIntersectionBoxes = () => {
        if (getExportRequest.length > 0) {
            for (let i = 0; i < getIntersectionDatesData.length; i++) {
                let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getIntersectionDatesData[i].Station_id && ele.date === getIntersectionDatesData[i].mainDate);
                if (indexExprot !== -1) {
                    if (document.getElementById('interSection-' + getIntersectionDatesData[i].Station_id + '-' + i) !== null) {
                        document.getElementById('interSection-' + getIntersectionDatesData[i].Station_id + '-' + i).checked = true;
                    }
                }
            }
        }
    }

    //This method is used for header all checkbox event

    const setAllCheckBox = (midDataArray) => {
        let tempArray = [];
        let checkAllValue = 1;
        let checkVolValue = 0;
        let checkClassValue = 0;
        let checkSpeedValue = 0;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < midDataArray.length; i++) {
                if (!midDataArray[i].volume || !midDataArray[i].class || !midDataArray[i].speed) {
                    checkAllValue = 0;
                }
                if (midDataArray[i].volume) {
                    checkVolValue = 1;
                }
                if (midDataArray[i].class) {
                    checkClassValue = 1;
                }
                if (midDataArray[i].speed) {
                    checkSpeedValue = 1;
                }
            }

            tempArray.push({ all: checkAllValue, volume: checkVolValue, class: checkClassValue, speed: checkSpeedValue });
            resolve(tempArray);
        })
    }


    //This function is call for file download
    const exportFile = () => {
        setErrMsg(null);
        //setExportLoader(true);
        setExportStatus(true);
        setExportFailedError('');
        let interSectionIn = parseInt(intersectionInterval);
        let midblockIn = parseInt(midblockInterval);
        let setExportData = getExportRequest;
        //refress token
        getCSRFtoken()
        
        setZipDownloadData(setExportData, interSectionIn, midblockIn).then(async result => {
            if (result.length > 0) {
                try {
                    axios({
                        method: 'post',
                        timeout: 600000,
                        data: {
                            input: result,
                            csv:csvExport,
                            pdf:pdfExport,
                            "isKph": await sessionStorage.getItem("isKph").toString() === "true" ? true : false
                        },
                        headers: {
                            'payload': Cookies.get('payload'),
                            'agencyid': sessionStorage.getItem('agency_id')
                        },
                        url: API_URL + API_PATH.export2csv,
                    })
                        .then(async function (response) {
                            if (response && response.status == '200') {
                                if (response.data && response.data.data) {
                                    let expoData = response.data.data;
                                    //
                                    downloadZipFile(expoData.file_name, expoData.bucket_name, expoData.folder_name);
                                }
                                else {
                                    //setExportLoader(false);
                                    setExportStatus(false);
                                    setExportFailedError('No Data available for export ... !');
                                    setErrMsgType('error')
                                    setErrMsg('No Data available for export');
                                    setErrPopUp(true);
                                }

                            } else {
                                //setExportLoader(false);
                                setExportStatus(false);
                                setExportFailedError('No Data available for export ... !');
                                setErrMsgType('error')
                                setErrMsg('No Data available for export');
                                setErrPopUp(true);
                            }
                        }).catch(err => {
                            console.log(err)
                            //setExportLoader(false);
                            setExportStatus(false);
                            setExportFailedError('Something went wrong ...!');
                            setErrMsgType('error')
                            setErrMsg('Something went wrong');
                            setErrPopUp(true);
                        })
                } catch (error) {
                    console.error(error);
                    //setExportLoader(false);
                    setExportStatus(false);
                    setExportFailedError('Export Failed try again ... !');
                    setErrMsgType('error')
                    setErrMsg('Export Failed try again');
                    setErrPopUp(true); 
                    setErrMsgType('error')
                    setErrMsg('Something went wrong');
                    setErrPopUp(true);
                }
            }
        }).catch(err => {
            console.log(err)
            //setExportLoader(false);
            setExportStatus(false);
            setExportFailedError('Something went wrong ...!');
        })
    }

    const ShowErrPopUp = () => {
        setErrPopUp(false)
    };

    //This function is used for aws credential logins
    const getAswToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getAWSs3TokenAPI,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            }).then(async function (response) {
                if (response.status && response.status == '200') {
                    let aswData = response.data;
                    setIdintityPool(aswData.data.IdentityPoolId);
                    setAswLogins(aswData.data.Logins);
                   
                } else {
                    console.log("");
                }
            })
        } catch (error) {
            console.error(error);
        }
    }
    //This function is used for aws credential logins

    //This function is used for download zip file
    const downloadZipFile = (file_name, bucket_name, folder_name) => {
        let OIDToken = Cookies.get('idToken');
       
        AWS.config.update(
            {
                region: 'us-west-2',
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: idintityPool,
                    Logins: {
                        [aswLogins]: OIDToken
                    }
                })
            }
        );
        AWS.config.credentials.clearCachedId();
        let s3 = new AWS.S3();
        s3.getObject({ Bucket: bucket_name, Key: folder_name + '/' + file_name }, function (
            error, data) {
            if (error != null) {
                console.log(error)
                //setExportLoader(false);
                setExportStatus(false);
                setExportFailedError(error.message);
            } else {
                let blob = new Blob([data.Body], { type: data.ContentType });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = file_name;
                link.click();
                //setExportRequest([]);
                //setExportLoader(false);
                setExportStatus(false);
                closeExportPopUp();
            }
        });
    };
    //This function is used for download zip file

    const setZipDownloadData = (setExportData, interSectionIn, midblockIn) => {
        let tempArray = [];
        return new Promise((resolve, reject) => {
            for (let i = 0; i < setExportData.length; i++) {
                if (setExportData[i].station_type == 'Midblock') {
                    tempArray.push({
                        station_id: setExportData[i].Station_Id,
                        date: setExportData[i].date,
                        day: getDayFromDate(setExportData[i].date),
                        interval_time: midblockIn,
                        speed: setExportData[i].speed,
                        class: setExportData[i].class,
                        volume: setExportData[i].volume,
                        dir_opt_seprate: optionSeparately,
                        dir_opt_combined: optionCombined,
                        station_type: setExportData[i].station_type,
                        consecutive_flag: setExportData[i].consecutive_flag,
                        consecutive_status: setExportData[i].consecutive_status
                    });
                }
                else {
                    tempArray.push({
                        station_id: setExportData[i].Station_Id,
                        date: setExportData[i].date,
                        day: getDayFromDate(setExportData[i].date),
                        interval_time: interSectionIn,
                        speed: setExportData[i].speed,
                        class: setExportData[i].class,
                        volume: setExportData[i].volume,
                        dir_opt_seprate: false,
                        dir_opt_combined: false,
                        station_type: setExportData[i].station_type,
                        consecutive_flag: setExportData[i].consecutive_flag,
                        consecutive_status: setExportData[i].consecutive_status
                    });
                }
            }
            resolve(tempArray);
        })
    }
    //This function is call for file download

    //This function is used for intersection set Data
    const selectIntersectionData = async (e, Station_Id, station_type, data_date) => {
        let speed = false;
        let clas = false;
        let volume = false;
        let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === Station_Id && ele.date === data_date);
        if (e.target.checked == true) {
            if(totalSelected > 0 ) {
                totalSelected -= 1;
                // partial selection
                setSelectedPartialRows([...selectedPartialRows, Station_Id]);
                setIndividualSelDate([...individualSelDate, Station_Id+"-"+data_date]);
                let newArr = [...getExportRequest];
                if (indexExprot === -1) {
                    newArr.push({ Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: speed, class: clas, volume: volume, consecutive_flag: 0, consecutive_status: false });
                } else {
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: getExportRequest[indexExprot].speed,
                        class: getExportRequest[indexExprot].class,
                        volume: getExportRequest[indexExprot].volume,
                        consecutive_flag: 0,
                        consecutive_status: false
                    };
                }
                setExportRequest(newArr);
                verifyAllSelection(newArr);
                verifySelectionByRow(newArr,Station_Id);
            }
        }
        else {
            let tmp = [...individualSelDate];
            let pos = tmp.indexOf(Station_Id+"-"+data_date);
            if(pos >= 0) {
                tmp.splice(pos, 1);
                setIndividualSelDate(tmp);
            }
            if (indexExprot !== -1) {
                let newArr = getExportRequest;
                newArr.splice(indexExprot, 1);
                totalSelected += 1;
                setExportRequest(newArr);
                verifyAllSelection(newArr);
            }
            removeFromSelectionByRow(Station_Id);
            removeFromPartialSelection(Station_Id);
        }
    }
    //This function is used for intersection set Data

    //This function is used for all midblock value
    const selectMidblockDataAll = async (e, Station_Id, station_type, data_date, consecutive_flag, consecutive_status, indexValue, volume, clas, speed) => {
        setCheckHtml(0);
        let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === Station_Id && ele.date === data_date);
        if (e.target.checked == true) {
            if(totalSelected > 0) {
                totalSelected -= 1;
                // partial selection
                setSelectedPartialRows([...selectedPartialRows, Station_Id]);
                setIndividualSelDate([...individualSelDate, Station_Id+"-"+data_date]);
                let newArr = [...getExportRequest];
                if (indexExprot === -1) {
                    newArr.push({ Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: speed, class: clas, volume: volume, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status });
                } else {
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: speed,
                        class: clas,
                        volume: volume,
                        consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                        consecutive_status: getExportRequest[indexExprot].consecutive_status
                    };
                }
                setExportRequest(newArr);
                verifyAllSelection(newArr);
                verifySelectionByRow(newArr,Station_Id);
            }
        }
        else {
            let tmp = [...individualSelDate];
            let pos = tmp.indexOf(Station_Id+"-"+data_date);
            if(pos >= 0) {
                tmp.splice(pos, 1);
                setIndividualSelDate(tmp);
            }
            if (indexExprot !== -1) {
                let newArr = [...getExportRequest];
                newArr.splice(indexExprot, 1);
                totalSelected += 1;
                setExportRequest(newArr);
                verifyAllSelection(newArr);
            }
            unselectHeaderCheckBoxes(Station_Id);
            removeFromSelectionByRow(Station_Id);
            removeFromPartialSelection(Station_Id);
        }

    }
    //This function is used for all midblock value   

    const verifySelectionByRow = (toExport, station_id) => {
        let tmpPartial = toExport.filter(item => item.Station_Id === station_id);
        let tmpAll = stationAllArray.filter(item => item.station_id === station_id);
        let tmpAllDates = [];
        if(tmpAll.length > 0 && tmpAll[0].data) {
            tmpAllDates = tmpAll[0].data;
            if( tmpAllDates.length === tmpPartial.length) {
                setSelectedRows([...selectedRows, station_id]);
            }
        }
    }

    const verifyAllSelection = (newArr) => {
        if(newArr.length === totalDates) {
            setSelectAll(true);
            setCheckedAll(true);
        } else {
            setSelectAll(false);
            if(newArr.length === maxFromDB)
                setCheckedAll(true);
            else
                setCheckedAll(false);
        }
    }

    const removeFromPartialSelection = (station_id) => {
        // remove from partial selection
        let tmpPartial = [...selectedPartialRows];
        let posPartial = tmpPartial.indexOf(station_id);
        if(posPartial >= 0) {
            tmpPartial.splice(posPartial, 1);
        }
        setSelectedPartialRows(tmpPartial);
    }

    const removeFromSelectionByRow = (station_id) => {
        // remove from partial selection
        let tmp = [...selectedRows];
        let pos = tmp.indexOf(station_id);
        if(pos >= 0) {
            tmp.splice(pos, 1);
        }
        setSelectedRows(tmp);
    }

    const setAllVolumeBox = () => {
        let allVolumeValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                if (document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i)) {
                    if (!document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i).checked) {
                        allVolumeValue = 0;
                    }
                }
            }
            resolve(allVolumeValue);
        })
    }

    const setAllClassBox = () => {
        let allClassValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                if (document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i)) {
                    if (!document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i).checked) {
                        allClassValue = 0;
                    }
                }
            }
            resolve(allClassValue);
        })
    }

    const setAllSpeedBox = () => {
        let allSpeedValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                if (document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i)) {
                    if (!document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i).checked) {
                        allSpeedValue = 0;
                    }
                }
            }
            resolve(allSpeedValue);
        })
    }

    //Interval option value change 
    const intervalHandleChange = (value) => {
        setIntersectionInterval(value);
    }
    //Interval option value change 

    //Midblock option value change 
    const midblockHandleChange = (value) => {
        setMidblockInterval(value);
    }
    //Midblock option value change 

    //This function is called for file export option
    const checkOptionSeparately = (e) => {
        setOptionSeparately(e.target.checked);
    }
    const checkOptionCombined = (e) => {
        setOptionCombined(e.target.checked);
    }
    //This function is called for file export option

    //This function is used for export btn 
    const exportToCsv = (e) => {
        
        
        if(e.target.value == "PDF"){
            if (e.target.checked == true) {
                setPdfExport(true)
            }
            else {
                setPdfExport(false)
            }
        
           
        }else if (e.target.value == "CSV"){
            if (e.target.checked == true) {
                setCsvExport(true)
            }
            else {
                setCsvExport(false)
            }

        } 

       /* if (e.target.checked == true) {
            setExportBtnStatus(true);
        }
        else {
            setExportBtnStatus(false);
        }*/
    }
    //This function is used for export btn   

    //This code is uded for close pop up
    const closeExportPopUp = () => {
        props.checkExportValue();
        setExportRequest([]);
    }
    //This code is uded for close pop up   

    const getDayFromDate = (date) => {
        return parseInt(date.split('-')[2]);
    }

    //This is to check consecutive dates selected for export
    const sequenceIsConsecutive = () => {
        let newArr = [...getExportRequest];
        if (exportAsSingleFile) {
            newArr.forEach(function(item, idx) {
                stationAllArray.forEach(function(station) {
                    if(station.station_type === 1) {
                        station.data.forEach(function(row, ind) {
                            if(item.date === row.mainDate) {
                                newArr[idx].consecutive_flag = row.consecutive_flag;
                                newArr[idx].consecutive_status = row.consecutive_status;
                            }
                        });
                    }
                })
            })
        } else {
            newArr = getExportRequest.map((val) => ({ ...val, consecutive_status: false, consecutive_flag: 0 }));
        }
        setExportRequest(newArr);
    }
    ///
    const getCSRFtoken = () => { // API call to get CSRF token 
    try {
        axios({
          method: 'get',
          url: API_URL + API_PATH.getcsrftoken,
        })
          .then(async function (response) {
            if (response && response.data && response.data.csrfToken) {
              axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken; //set CSRF token in request headers
              getAccessToken(response.data.csrfToken);
            } else {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
              window.location.href = '/';
            }
          })
          .catch(function (error) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
            window.location.href = '/';
          })
      } catch (error) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
        clearCookie('alLogIn');
        window.location.href = '/';
      }
    }
  
    const getAccessToken = (csrfToken) => { //API call to request access token
      try {
        axios({
          method: 'post',
          data: {
            email: Cookies.get('email'),
            rememberMe: Cookies.get('alLogIn') == 'false' ? false : true
          },
          url: API_URL + API_PATH.getRefreshToken,
          'X-CSRF-TOKEN': csrfToken
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              if (response.data.payload) {
                setCookie('idToken', response.data.IdToken);
                setCookie('payload', response.data.payload);
                setCookie('atexpiry', response.data.access_token_expiry);
              } else {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                clearCookie('alLogIn');
                window.location.href = '/';
              }
            } else {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
              window.location.href = '/';
            }
          })
          .catch(function (error) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
            window.location.href = '/';
          })
      } catch (error) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
        clearCookie('alLogIn');
        window.location.href = '/';
      }
    }

    const nextSteep1 =()=>{
        setSteep1(false)
        setSteep2(true)
        setSteep3(false)
        // if (stationTypeName == 1) {
            sequenceIsConsecutive();
        // }
        let count = counter;
        if (count < data.length) {
            count = count + 1;
            stationCount = stationCount + 1;
        }
        setCounter(count);
        pageData(count);
        setExportFailedError('');
        setCheckHtml(1);
        setCounter(count);
    }

    const nextSteep2 =()=>{
        setSteep1(false)
        setSteep2(false)
        setSteep3(true)
    }

    const backSteep2 =()=>{
        setSteep1(true)
        setSteep2(false)
        setSteep3(false)
    }
    const backSteep3 =()=>{
        setSteep1(false)
        setSteep2(true)
        setSteep3(false)
    }
    const showfilterPanelMid=()=>{
        setShowIntersection(false);
        setShowMidblock((showMidblock) => !showMidblock);
       
        
      }
      const showfilterPanelInt=()=>{
        setShowMidblock(false);
        setShowIntersection((showIntersection) => !showIntersection);
      }

   //This method is use for volume Count .... Start
  const volumeCount = (event) => {
    let volCount = volume_count;
    updateFilterisactive(true)
    updateMainFilter('volume',event.target.checked)
    
  }
  //This method is use for get volume Count .... End

  //This method is use for vehicle Class .... Start
  const vehicleClass = (event) => {
    let vehiClass = vehicle_class;
    updateFilterisactive(true)
    updateMainFilter('class',event.target.checked)
    
  }
  //This method is use for vehicle Class .... End

  //This method is use for traffic Speed .... Start
  const trafficSpeed = (event) => {
    let traffSpeed = traffic_speed;
    updateFilterisactive(true)
    updateMainFilter('speed',event.target.checked)
    
  }
  //This method is use for traffic Speed .... end
 
  //This method is use for get turning Count data.... start
  const turningCount = (event) => {
    let turnCount = turning_count;
    updateFilterisactive(true)
    updateMainFilter('turn',event.target.checked)
    
  }
  //This method is use for get turning Count data.... end

  //This method is use for get pedestrian Count data .... start
  const pedestrianCount = (event) => {
    let pedesCount = pedestrian_count;
    updateFilterisactive(true)
    updateMainFilter('pedestrian',event.target.checked)
    
  }
  //This method is use for get pedestrian Count data .... End

  //This method is use for get Bicycle Count data .... Start
  const bicycleCount = (event) => {
    let bicycCount = bicycle_count;
    updateFilterisactive(true)
    updateMainFilter('bicycle',event.target.checked)
    
  }
  //This method is use for get Bicycle Count data .... End

 const filterTable=()=>{
     let temporal=[]
     const copyArr = [...stationAllArrayTemp];
    
     copyArr.forEach(function(value,index,array){
        let temporal1=value;
         if(temporal1.station_type=='Midblock'){
             //filter by  class speed volume
             let temporalValue=temporal1.data2;
             let _subArray_mid=[]
             temporalValue.forEach(function(subValue,subIndex,suArray){
                if(!filter.class && !filter.speed && !filter.volume){
                    //validate date
                   // mainDate
                   let _maindate=subValue.mainDate.split('-')
                   let tempDate=new Date(_maindate[0],_maindate[1]-1,_maindate[2])
                   
                   let _startDate=filter.startDate.split('-')
                   let tempstartDate=new Date(_startDate[0],_startDate[1],1)
                   
                   let _endDate=filter.endDate.split('-')
                   let tempendDate=new Date(_endDate[0],_endDate[1])
                   
                   if(filter.startDate1!='' && filter.endDate!=''){
                       if(tempDate>=tempstartDate && tempDate<=tempendDate) {
                        _subArray_mid.push(subValue)
                       } 
                   }else if(!filter.turning && !filter.bicycle && !filter.pedestrian){
                        _subArray_mid.push(subValue)
                   }
                       
                    
                }
                if(filter.class && !filter.speed && !filter.volume){
                    if(subValue.class ){
                        //solo los que tiene cs
                        _subArray_mid.push(subValue)
                    }

                }
                if(filter.class && filter.speed && !filter.volume){
                    if(subValue.class && subValue.speed ){
                        //solo los que tiene cs
                        _subArray_mid.push(subValue)
                    }
                }
                if(filter.class && !filter.speed && filter.volume){
                    if(subValue.class || subValue.volume ){
                        //solo los que tiene cs
                        _subArray_mid.push(subValue)
                    }
                }
                
                if(filter.class && filter.speed && filter.volume){
                    if(subValue.class || subValue.speed || subValue.volume  ){
                        //solo los que tiene cs
                        _subArray_mid.push(subValue)
                    }
                    
                }

                if(!filter.class && filter.speed && !filter.volume){
                    if( subValue.speed  ){
                        //solo los que tiene cs
                        _subArray_mid.push(subValue)
                    }
                    
                }

                if(!filter.class && filter.speed && filter.volume){
                    if(subValue.speed || subValue.volume  ){
                        //solo los que tiene cs
                        _subArray_mid.push(subValue)
                    }
                    
                }
                if(!filter.class && !filter.speed && filter.volume){
                    if(subValue.volume  ){
                        //solo los que tiene cs
                        _subArray_mid.push(subValue)
                    }
                }

            })

            if(_subArray_mid.length>0){
                temporal1.data=_subArray_mid
                temporal.push(temporal1)
            } else {
                temporal1.data=[]
                temporal.push(temporal1)
            }
         }else if(temporal1.station_type=='Intersection') {
            //filter by  bicycle, pedestrian, counting
            let temporalValue=temporal1.data2;
            let _subArray_Int=[]
            temporalValue.forEach(function(subValue,subIndex,suArray){
                if(!filter.bicycle && !filter.pedestrian && !filter.turn){
                    let _maindate=subValue.mainDate.split('-')
                    let tempDate=new Date(_maindate[0],_maindate[1]-1,_maindate[2])
                    let _startDate=filter.startDate.split('-')
                    let tempstartDate=new Date(_startDate[0],_startDate[1],1)
                    let _endDate=filter.endDate.split('-')
                    let tempendDate=new Date(_endDate[0],_endDate[1],31)
                    if(filter.startDate1!='' && filter.endDate!=''){
                        if(tempDate>=tempstartDate && tempDate<=tempendDate) {
                         _subArray_Int.push(subValue)
                        } 
                    }else if(!filter.volume && !filter.class && !filter.speed){
                     _subArray_Int.push(subValue)
                    }
                    
                }

                if(filter.bicycle && !filter.pedestrian && !filter.turn){
                    if(subValue.bicycle ){
                        //solo los que tiene cs
                        _subArray_Int.push(subValue)
                    }

                }
                if(filter.bicycle && filter.pedestrian && !filter.turn){
                    if(subValue.bicycle && subValue.pedestrian ){
                        //solo los que tiene cs
                        _subArray_Int.push(subValue)
                    }
                }
                if(filter.bicycle && !filter.pedestrian && filter.turn){
                    if(subValue.bicycle || subValue.turning ){
                        //solo los que tiene cs
                        _subArray_Int.push(subValue)
                    }
                }
                
                if(filter.bicycle && filter.pedestrian && filter.turn){
                    if(subValue.bicycle || subValue.pedestrian || subValue.turning  ){
                        //solo los que tiene cs
                        _subArray_Int.push(subValue)
                    }
                    
                }

                if(!filter.bicycle && filter.pedestrian && !filter.turn){
                    if( subValue.pedestrian  ){
                        //solo los que tiene cs
                        _subArray_Int.push(subValue)
                    }
                    
                }

                if(!filter.bicycle && filter.pedestrian && filter.turn){
                    if(subValue.pedestrian || subValue.turning  ){
                        //solo los que tiene cs
                        _subArray_Int.push(subValue)
                    }
                    
                }
                if(!filter.bicycle && !filter.pedestrian && filter.turn){
                    if(subValue.turning  ){
                        //solo los que tiene cs
                        _subArray_Int.push(subValue)
                    }
                }
    
            })

            if(_subArray_Int.length>0){
                temporal1.data=_subArray_Int
                temporal.push(temporal1)
            } else {
                temporal1.data=[]
                temporal.push(temporal1)
            }
           
         }
         //setDataTable(temporal)
     })
     
     stationAllArray=[...temporal]
 }

  //This method is use for show stations .... End

  const clearFilterInt = () => {  
    setFilter({...filter,
        turn:false,
        pedestrian:false,
        bicycle:false})
  }

  
  const clearFilterMid = () => {    
    setFilter({...filter,
        volume:false,
        class:false,
        speed:false})
  }
   
   //This method is use for change start date .... Start
   const handleStartDateChange = (e) => {
    setIsOpenTo(false)
    let date = new Date(e.getFullYear(), e.getMonth(), 1);
    setSelectedStartDate(date);
    setStartDatePicker(date);
    prevStartDate = date;
    prevEndDate = getSelectedEndDate;
    let tempDate=e.getFullYear()+'-'+e.getMonth()
    updateMainFilter('startDate',tempDate)
    updateFilterisactive(true)
    setTimeout(() => updateFilterisactive(false), 1000);

  }
  //This method is use for change start date .... End

  //This method is use for change end date .... Start
  const handleEndDateChange = (e) => {
    setIsOpenFrom(false)
    let currentMonth = new Date();
    let date = null;
    let datePickerVal = e;
    if (e.getMonth() !== (currentMonth.getMonth())) {
      date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth() + 1, 0);
    } else {
      if ((currentMonth.getFullYear() == datePickerVal.getFullYear())) {
        date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth(), currentMonth.getDate());
      } else {
        date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth() + 1, 0);
      }
    }
    setSelectedEndDate(date);
    setEndDatePicker(date);

    prevEndDate = date;
    prevStartDate = getSelectedStartDate;
    let tempDate=datePickerVal.getFullYear()+'-'+datePickerVal.getMonth()
    updateFilterisactive(true)
    updateMainFilter('endDate',tempDate)
    setTimeout(() => updateFilterisactive(false), 1000);

  }
  //This method is use for change end date .... End

  const handleScroll = () => {
    if (tableBodyRef.current) {
      const { scrollTop } = tableBodyRef.current;
      if (scrollTop > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
 };  

    const handleSelectAll = (e) => {
        setMostRecentChecked(false);
        setMostRecentDate([]);
        setCheckedAll(!checkedAll);
        totalSelected = maxFromDB;
        if(e.target.checked) {
            // setSelectAll(true);
            let indArr = [];
            let partRow = [];
            let selRows = [];
            let newArr = [];
            stationAllArray.forEach(function(station, indst) {
                let st_type = station.station_type;
                station.data.forEach(function(row, ind) {
                    // let tmpExport = getExportRequest.filter(item => item.Station_Id === row.Station_id && item.date === row.mainDate);
                    // if(tmpExport.length === 0) {
                        if(totalSelected > 0) {
                            let obj = st_type === 'Intersection' ? 
                                {
                                    Station_Id: row.Station_id,
                                    station_type: row.station_type,
                                    date: row.mainDate,
                                    day: getDayFromDate(row.mainDate),
                                    pedestrian: row.pedestrian,
                                    turning: row.turning,
                                    bicycle: row.bicycle,
                                    consecutive_flag: 0,
                                    consecutive_status: false
                                }
                                : {
                                    Station_Id: row.Station_id,
                                    station_type: row.station_type,
                                    date: row.mainDate,
                                    day: getDayFromDate(row.mainDate),
                                    speed: row.speed,
                                    class: row.class,
                                    volume: row.volume,
                                    consecutive_flag: row.consecutive_flag,
                                    consecutive_status: row.consecutive_status
                                };
                            newArr.push(obj);
                            partRow.push(row.Station_id);
                            indArr.push(row.Station_id+"-"+row.mainDate);
                            totalSelected -= 1;
                        }
                    // }
                    verifySelectionByRow(newArr, row.Station_id);
                });
                setSelectedPartialRows(partRow);
                setIndividualSelDate(indArr);
                // verify selection by row for intermediate state
                let tmpPartial = newArr.filter(item => item.Station_Id === station.station_id);
                let tmpAll = stationAllArray.filter(item => item.station_id === station.station_id);
                let tmpAllDates = [];
                if(tmpAll.length > 0 && tmpAll[0].data) {
                    tmpAllDates = tmpAll[0].data;
                    if( tmpAllDates.length === tmpPartial.length) {
                        selRows.push(station.station_id);
                    }
                }
            })
            setSelectedRows(selRows);
            verifyAllSelection(newArr);
            setExportRequest(newArr);
        } else {
            setSelectAll(false);
            setSelectedRows([]);
            setIndividualSelDate([]);
            setExportRequest([]);
            setSelectedPartialRows([]);
        }
    }

    const selectAllByRow = (e, ind, station_id) => {
        if(e.target.checked) {
            // adding to array to select checkbox
            setSelectedRows([...selectedRows, station_id]);
            // adding to export array if does not exist
            let newArr = [...getExportRequest];
            let indArr = [...individualSelDate];
            let partArr = [...selectedPartialRows];
            let st_type = stationAllArray[ind].station_type;
            stationAllArray[ind].data.forEach(function(row, ind) {
                let tmpExport = getExportRequest.filter(item => item.Station_Id === station_id && item.date === row.mainDate);
                if(tmpExport.length === 0) {
                    if(totalSelected > 0) {
                        let obj = st_type === 'Intersection' ? 
                            {
                                Station_Id: row.Station_id,
                                station_type: row.station_type,
                                date: row.mainDate,
                                day: getDayFromDate(row.mainDate),
                                pedestrian: row.pedestrian,
                                turning: row.turning,
                                bicycle: row.bicycle,
                                consecutive_flag: 0,
                                consecutive_status: false
                            }
                        : {
                            Station_Id: row.Station_id,
                            station_type: row.station_type,
                            date: row.mainDate,
                            day: getDayFromDate(row.mainDate),
                            speed: row.speed,
                            class: row.class,
                            volume: row.volume,
                            consecutive_flag: row.consecutive_flag,
                            consecutive_status: row.consecutive_status
                        };
                        newArr.push(obj);
                        indArr.push(row.Station_id+'-'+row.mainDate);
                        partArr.push(row.Station_id);;
                        totalSelected -= 1;
                    }
                }
            })
            setIndividualSelDate(indArr);
            setSelectedPartialRows(partArr);
            setExportRequest(newArr);
            verifyAllSelection(newArr);
        } else {
            // uncheck the checkbox
            let tmp = [...selectedRows];
            let pos = tmp.indexOf(station_id);
            if(pos >= 0) {
                tmp.splice(pos, 1);
                setSelectedRows(tmp);
            }
            // removing fron export array
            let newArr = [...getExportRequest];
            let tmpInd = [...individualSelDate];
            stationAllArray[ind].data.forEach(function(row, ind) {
                if(row.Station_id === station_id) {
                    let dt = row.mainDate;
                    let posExp = null;
                    // remove from export array
                    newArr.forEach(function(rowExp, indExp){
                        if(rowExp.date === dt) {
                            posExp = indExp;
                            if(posExp >= 0) {
                                newArr.splice(posExp, 1);
                                totalSelected += 1;
                            }
                        }
                    });
                    // remove from individual selection 
                    let posInd = tmpInd.indexOf(station_id+"-"+dt);
                    if(posInd >= 0) {
                        tmpInd.splice(posInd, 1);
                    }
                }
            });
            setIndividualSelDate(tmpInd);
            setExportRequest(newArr);
            // remove all from partial selection
            let tmpPartial = [...selectedPartialRows];
            let posPartial = 0;
            while(posPartial >= 0) {
                posPartial = tmpPartial.indexOf(station_id);
                if(posPartial >= 0) {
                    tmpPartial.splice(posPartial, 1);
                }
            }
            setSelectedPartialRows(tmpPartial); 
            verifyAllSelection(newArr);
        }
    }

    const handleMostRecentData = (e) => {
        setMostRecentChecked(!mostRecentChecked)
        // getting the most recent date by station
        let mostRecDates = [];
        stationAllArray.forEach(function(station) {
            if(station.data && station.data[0]) {
                mostRecDates.push(station.data[0].Station_id+"-"+station.data[0].mainDate);
            }
        });
        if(e.target.checked) {
            // adding to export array
            setSelectAll(false);
            setSelectedRows([]);
            setIndividualSelDate([]);
            setExportRequest([]);
            setSelectedPartialRows([]);
            totalSelected = maxFromDB;
            let newArr = [];
            let newpartial = [];
            stationAllArray.forEach(function(station,indst) {
                let st_type = station.station_type;
                station.data.forEach(function(row, ind) {
                    if(totalSelected > 0) {
                        if(mostRecDates.includes(row.Station_id+"-"+row.mainDate)) {
                            let obj = st_type === 'Intersection' ? 
                            {
                                Station_Id: row.Station_id,
                                station_type: row.station_type,
                                date: row.mainDate,
                                day: getDayFromDate(row.mainDate),
                                pedestrian: row.pedestrian,
                                turning: row.turning,
                                bicycle: row.bicycle,
                                consecutive_flag: 0,
                                consecutive_status: false
                            }
                            : {
                                Station_Id: row.Station_id,
                                station_type: row.station_type,
                                date: row.mainDate,
                                day: getDayFromDate(row.mainDate),
                                speed: row.speed,
                                class: row.class,
                                volume: row.volume,
                                consecutive_flag: row.consecutive_flag,
                                consecutive_status: row.consecutive_status
                            };
                            newArr.push(obj);
                            totalSelected -= 1;
                            // partial selection
                            newpartial.push(row.Station_id);
                        }
                    }
                })
            })
            setSelectedPartialRows(newpartial);
            setExportRequest(newArr);
            setMostRecentDate(mostRecDates);
            verifyAllSelection(newArr);
        } else {
            // removing fron export array
            let newArr = [...getExportRequest];
            let newpartial = [...selectedPartialRows];
            stationAllArray.forEach(function(station) {
                station.data.forEach(function(row, ind) {
                    if(mostRecDates.includes(row.Station_id+"-"+row.mainDate)) {
                        let dt = row.mainDate;
                        let posExp = null;
                        newArr.forEach(function(rowExp, indExp){
                            if(rowExp.date === dt) {
                                posExp = indExp;
                            }
                        });
                        if(posExp >= 0) {
                            newArr.splice(posExp, 1);
                            totalSelected += 1;
                        }
                        // remove from partial selection 
                        let posInd = newpartial.indexOf(row.Station_id);
                        if(posInd >= 0) {
                            newpartial.splice(posInd, 1);
                        }
                    }
                });
            });
            setSelectedPartialRows(newpartial);
            setExportRequest(newArr);
            setMostRecentDate([]);
        }
    }

    const clearAllFilters = () => {
        updateFilterisactive(true)
        let currentDate = new Date()
        setEndDatePicker(null)
        setStartDatePicker(null)
        setSelectedEndDate(currentDate.getFullYear());
        clearFilterYear()
        setFilter({...filter,
            volume:false,
            class:false,
            speed:false,
            turn:false,
            pedestrian:false,
            bicycle:false,
            startDate:"",
            endDate:""
        })
        setTimeout(() => updateFilterisactive(false), 1000);
    }

    const clearFilterYear=()=>{
        setFilter({...filter,         
          startDate:"",
          endDate:""})
    }

    return (
        <React.Fragment>
            <div className={classes.ExternalMainBlock} style={{ height: window.screen.width >= 1550 && window.screen.width <= 1750 ? '100%' : window.screen.width >= 1751 && window.screen.width <= 3500? '100%' : window.screen.width >= 3501? '100%' :'100%' }}>
            {steep1?
             <div className={'export-data-main-panel'} style={{ pointerEvents: 'visible', top: window.screen.width >= 1550 && window.screen.width <= 1750 ? '0px' : window.screen.width >= 1751 && window.screen.width <= 3500 ? '0px' : window.screen.width >= 3501 ? '0px' : '0px' }}>
                   
             <div className={'export-data-header'}>
                 <div className={'export-data-header-content'}>
                     <div className="export-data-title">Export station data</div>
                     <div>
                     <img src={require('../../assets/icons/Steps_1.png')}  style={{ marwidth:"256px",height:"32px",    marginLeft: '172px'}}/>                                </div>
                     <div>
                    
                    
                     </div>
                     <div className={'export-close-icon'}> <img src={require('../../assets/icons/close-black.png')} style={{cursor:'pointer'}} onClick={closeExportPopUp} /></div>
                 </div>
             </div>
             <div className={'export-data-content'}>
                 <div className={'export-data-filter'}>
                     <Button 
                        onClick={showfilterPanelMid} 
                        className={`bg-gray-white  txt-gray-700 btn-export-data-filter ${filter.volume || filter.speed || filter.class ? "filter-active" : ""}`}
                        variant="outlined" 
                        disabled={totalMid === 0}
                    >
                            Midblock  <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" /> 
                    </Button>
                    <Button 
                     onClick={showfilterPanelInt} 
                     className={`bg-gray-white  txt-gray-700 bg-gray-white btn-export-data-filter ${filter.turn || filter.bicycle || filter.pedestrian ? "filter-active" : ""}`} 
                     variant="outlined" 
                     disabled={totalInt === 0}
                    >
                         Intersection <img src={require('../../assets/icons/down-arrow.png')} className="icon-chev" />
                    </Button>

                     <MuiPickersUtilsProvider utils={LocalizedUtils} className="md-screen">
                            <KeyboardDatePicker
                                autoOk
                                InputProps={{ readOnly: true }}
                                allowSameDateSelection={true}
                                clearable
                                variant="inline"
                                label={(startDatePicker!=null && startDatePicker!='') ?'':'From'}
                                value={startDatePicker}
                                inputVariant="outlined"
                                onChange={handleStartDateChange}
                                onClick={()=>{
                                setIsOpenTo(false);
                                setIsOpenFrom(true);
                                setShowMidblock(false);
                                setShowIntersection(false);
                                }}
                                onMonthChange={()=>{setIsOpenFrom(false)}}
                                openTo="year"
                                views={["year", "month",]}
                                invalidLabel=""
                                invalidDateMessage=""
                                emptyLabel=""
                                className={(startDatePicker!=null && startDatePicker!='') ?'date-picker':'date-picker-null'}
                                keyboardIcon={(startDatePicker!=null && startDatePicker!='') ?<img src={require('../../assets/icons/calendar-blue.png')}/>:<img src={require('../../assets/icons/calendar.png')}/>}
                                
                            />
                     </MuiPickersUtilsProvider>
       
                     <MuiPickersUtilsProvider utils={LocalizedUtils} className="md-screen">
                             <KeyboardDatePicker
                             autoOk
                             
                                 label={(endDatePicker!=null && endDatePicker!='') ?'':'To'}
                                 value={endDatePicker}
                                 variant="inline"
                                 inputVariant="outlined"
                                 variant="inline"
                                 openTo="year"
                                 views={["year", "month",]}
                                 display= "grid"
                                 invalidLabel=""
                                 invalidDateMessage=""
                                 emptyLabel=""
                                 onChange={handleEndDateChange}
                                 onClick={()=>{setIsOpenFrom(false);
                                    setIsOpenTo(true);
                                    setShowMidblock(false);
                                    setShowIntersection(false);}}
                                  onMonthChange={()=>{setIsOpenTo(false)}}
                                 className={(endDatePicker!=null && endDatePicker!='') ?'date-picker':'date-picker-null-to'}
                                 keyboardIcon={(endDatePicker!=null && endDatePicker!='') ?<img src={require('../../assets/icons/calendar-blue.png')} />:<img src={require('../../assets/icons/calendar.png')}/>}
                             />
                     </MuiPickersUtilsProvider>
                     {(filter.class || filter.volume || filter.speed || filter.turn || filter.pedestrian || filter.bicycle) || endDatePicker!=null && startDatePicker!=null ?
                        <Button 
                            className={'clear-filter-btn-details'}
                            onClick={clearAllFilters}
                            >
                            Clear 
                        </Button> : null
                    }
                     <FormControlLabel control={<StyledCheckbox checked={mostRecentChecked} onChange={handleMostRecentData} />} label="Most recent data only" className={'chbx-export'}/>
                 </div>
                 {showMidblock?
            <ClickAwayListener onClickAway={() => setShowMidblock(false)}>
                <div className={'filter-midblock-export'}>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox checked={filter.volume} />} label="Volume count" onChange={volumeCount} style={{height: '36px'}}/>
                    <FormControlLabel  control={<Checkbox checked={filter.class} />} label="Vehicle class" onChange={vehicleClass} style={{height: '36px'}} />
                    <FormControlLabel  control={<Checkbox checked={filter.speed} />} label="Vehicle speed" onChange={trafficSpeed} style={{height: '36px'}} />
                  </FormGroup>
                  <div className="clear-filter-container">
                    
                  <Button 
                  className={'clear-filter-btn'}
                  onClick={clearFilterMid}
                  >
                  Clear filters 
                  </Button>
                  </div>
                </div>
            </ClickAwayListener>
        :
        null
      }
      {showIntersection?
        <ClickAwayListener onClickAway={() => setShowIntersection(false)}>
            <div className={'filter-intersection-export'}>
            <FormGroup>
            <FormControlLabel control={<Checkbox checked={filter.turn}/>} label="Turning count" onChange={turningCount}/>
            <FormControlLabel  control={<Checkbox checked={filter.pedestrian} />} label="Pedestrian count"  onChange={pedestrianCount} />
            <FormControlLabel   control={<Checkbox checked={filter.bicycle}
                                        onChange={bicycleCount}
                                        id="bicycle_count" />} label="Bicycle count"/>
            </FormGroup>
            <div className="clear-filter-container">
            <Button 
            className={'clear-filter-btn'}
            onClick={clearFilterInt}
            >
            Clear filters 
            </Button>

            </div>

            </div>
        </ClickAwayListener>
        :
        null
      }
                 <div className={'export-data-table'}>
                     <div className={'export-data-table-title'}>
                        <label>Stations</label>
                        <label className={totalSelected === 0 ? 'no-days-left' : ''}>{totalSelected} selected days left</label>
                     </div>
                     <div className={'export-data-table-content'} >
                     <TableContainer className={classes.container}>
                            <Table stickyHeader  className={classes.tableMid} aria-label="customized table">
                            <TableHead className={scrolled && 'table-scrolled'}>
                            <TableRow>
                                <TableCell  style={{ width: '48px' }} className={'font-default-12 zebra'}/>
                                <TableCell padding="checkbox" style={{ width: '48px' }} className={'font-default-12 zebra'}>
                                    <label >
                                        <StyledCheckbox 
                                            checked={checkedAll} 
                                            onChange={handleSelectAll} 
                                            indeterminate={getExportRequest.length > 0 && !selectAll}
                                        />
                                    </label>
                                </TableCell>
                                <TableCell style={{ width: '350px' }} className={'font-default-12 zebra'}><div className={'padding_10_16'}>Name</div></TableCell >
                                <TableCell align="right" style={{ width: '250px' }} className={'font-default-12 zebra'}><div className={'padding_10_16'}>Station id</div></TableCell>
                                <TableCell align="right" style={{ width: '150px' }} className={'font-default-12 zebra'}><div className={'padding_10_16'}>Type</div></TableCell>
                                
                            </TableRow>   
                            </TableHead>
                            <TableBody className="table-body" onScroll={handleScroll} ref={tableBodyRef}>
                            {stationAllArray.map((row, indrow) => (
                                <Row key={row.station_id} 
                                    row={row}
                                    selectMidblockDataAll={selectMidblockDataAll}
                                    getMidblockDatesData={getMidblockDatesData}
                                    getCheckHtml={getCheckHtml}
                                    checkHeaderCheckBoxes={checkHeaderCheckBoxes}
                                    selectIntersectionData={selectIntersectionData}
                                    getIntersectionDatesData={getIntersectionDatesData}
                                    checkIntersectionBoxes={checkIntersectionBoxes}
                                    indrow={indrow}
                                    selectAllByRow={selectAllByRow}
                                    selectedRows={selectedRows}
                                    selectAll={selectAll}
                                    individualSelDate={individualSelDate}
                                    mostRecentChecked={mostRecentChecked}
                                    mostRecentDate={mostRecentDate}
                                    selectedPartialRows={selectedPartialRows}
                                />
                            ))}
                            {
                                loadingInfo &&
                                <div className="loader"></div>
                            }
                            </TableBody>
                        </Table>
                     </TableContainer>
                    
                     </div>
                     <div className={'export-data-footer-det'} style={totalMid > 0  ? {justifyContent:"space-between"} : {justifyContent: "flex-end"}}>
                         {
                             totalMid > 0 &&
                            <div>
                                {/* <input type='checkbox' name='consi-check' value='consi-check'  onChange={(e) => { selectConsecutiveDates(e) }} checked={exportAsSingleFile} /> */}
                                <FormControlLabel control={<StyledCheckbox  onChange={(e) => { setExportAsSingleFile(!exportAsSingleFile) }} checked={exportAsSingleFile} />} label="Combine consecutive midblock days as a single file" className={'chbx-export-combine'} style={{paddingLeft: '16px'}} />
                            </div>
                         }
                         <div>
                            <Button type='button' id='exportBact_btn' className={'txt-gray-700 cancel-btn font-14 '} onClick={closeExportPopUp}>Cancel</Button>
                            <Button className={'txt-gray-white blue-btn font-14'} id='exportNext_btn'  onClick={nextSteep1} disabled={getExportRequest.length === 0}>Next</Button>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
            :
            null}
                   {steep2?
                   <div className={'export-data-main-panelstep2'} style={{ pointerEvents: 'visible', top: window.screen.width >= 1550 && window.screen.width <= 1750 ? '0px' : window.screen.width >= 1751 && window.screen.width <= 3500 ? '0px' : window.screen.width >= 3501 ? '0px' : '0px' }}>
                   
                   <div className={'export-data-header'}>
                       <div className={'export-data-header-content'}>
                           <div>Export station data</div>
                           <div className="stepper-cnt">
                           <label className="step-1" onClick={backSteep2}></label>
                           <img src={require('../../assets/icons/Steps_2.png')}  style={{ marwidth:"256px",height:"32px",    marginLeft: '30px'}}/>                                </div>
                           <div>
                           </div>
                           <div className={'export-close-icon'}> <img src={require('../../assets/icons/close-black.png')} style={{cursor:'pointer'}} onClick={closeExportPopUp} /></div>
                       </div>
                   </div>
                   <div className={'export-data-content'}>
                      
                       <div >

                           

                           {getExportRequest.length && getExportRequest.length > 0 ?
                            <>
                                {intersectionStatus == 1 ? <div>
                                    <div className={'interval-container'}>
                                    <div className={'interval-title'} >Intersection - Interval options</div>
                                        
                                        <div className={'interval-container-radios'}>
                                            {/* <RadioGroup row aria-label="interval_option" className={'interval-container-radios'} name="intersection_interval" value={intersectionInterval} name="interval_option" onChange={(e) => intervalHandleChange(e.target.value)}> */}
                                                    <div className={ intersectionInterval === '15' ? 'interval-container-r1 active-opt' : 'interval-container-r1'} onClick={() => intervalHandleChange('15')}> 
                                                        <FormControlLabel
                                                            checked={intersectionInterval==='15'}
                                                            value={'15'}
                                                            control={<Radio color="primary" />}
                                                            label='15-minute intervals'
                                                        />
                                                    </div>
                                                    <div className={ intersectionInterval === '5' ? 'interval-container-r2 active-opt' : 'interval-container-r2'} onClick={() => intervalHandleChange('5')}>
                                                        <FormControlLabel
                                                            checked={intersectionInterval==='5'}
                                                            value={'5'}
                                                            control={<Radio color="primary" />}
                                                            label='5-minute intervals'
                                                        />
                                                    </div>
                                             {/* </RadioGroup> */}

                                        </div>
                                   
                                    </div>
                                </div> : null}
                                {midblockStatus == 1 ? <div>
                                    <div className={'interval-container'}>
                                        <div className={'interval-title'} >Mid block - Interval options</div>
                                        <div className={'interval-container-radios'}>
                                            {/* <RadioGroup row aria-label="interval_option"   className={'interval-container-radios'} name="interval_option" value={midblockInterval}  onChange={(e) => midblockHandleChange(e)}> */}
                                                <div className={ midblockInterval === '60' ? 'interval-container-r1 active-opt' : 'interval-container-r1'} onClick={() => midblockHandleChange('60')}>
                                                    <FormControlLabel
                                                        checked={midblockInterval==='60'}
                                                        value={'60'}
                                                        control={<Radio color="primary" />}
                                                        label='60-minute intervals'
                                                    />
                                                </div>
                                                <div className={ midblockInterval === '15' ? 'interval-container-r2 active-opt' : 'interval-container-r2'} onClick={() => midblockHandleChange('15')}>
                                                    <FormControlLabel
                                                        checked={midblockInterval==='15'}
                                                        value={'15'}
                                                        control={<Radio color="primary" />}
                                                        label='15-minute intervals'
                                                    />
                                                </div>
                                            {/* </RadioGroup> */}
                                        </div>

                                    </div>
                                    <div className={'interval-container'}>
                                        <div className={'interval-title'} >Direction options</div>
                                            <div>
                                            <FormControl component="fieldset" className={'direction_option'} >
                                            <div className={classes.intervalOptionBlock}>
                                                <StyledCheckbox
                                                    defaultChecked
                                                    color="primary"
                                                    value='Separate directions'
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    onChange={(e) => { checkOptionSeparately(e) }}
                                                />Separate directions
                                    </div>
                                            <div className={classes.intervalOptionBlock}>
                                                <StyledCheckbox
                                                    defaultChecked
                                                    color="primary"
                                                    value='Combined'
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    onChange={(e) => { checkOptionCombined(e) }}
                                                />Combined
                                    </div>
                                        </FormControl>
                                            </div>    
                                         
                                    </div>    
                                 
                                </div> : null}
                            </> : null}
                       </div>
                   </div>
                   <div className={'export-data-footer'} style={{marginTop: '22px', justifyContent:'flex-end'}}>
                        <div>
                        <Button type='button' id='exportBact_btn'  type='button' className={'txt-gray-700 cancel-btn font-14 '}  style={{ width: '57px', height:'34px' }} onClick={backSteep2}>Back</Button>
                        <Button className={'txt-gray-white blue-btn font-14'} id='exportNext_btn'  style={{ width: '56px', height:'34px' }} onClick={nextSteep2}>Next</Button>
                        </div>      
                    </div>
               </div>
                   :null}
                   {steep3?
                     <div className={'export-data-main-panelstep3'} style={{ pointerEvents: 'visible', top: window.screen.width >= 1550 && window.screen.width <= 1750 ? '0px' : window.screen.width >= 1751 && window.screen.width <= 3500 ? '60px' : window.screen.width >= 3501 ? '0px' : '0px' }}>
                   
                     <div className={'export-data-header'}>
                         <div className={'export-data-header-content'}>
                             <div>Export station data</div>
                             <div className="stepper-cnt">
                                <label className="step-1" onClick={backSteep2} style={exportStatus ? {pointerEvents: 'none'} : null}></label>
                                <label className="step-2" onClick={backSteep3} style={exportStatus ? {pointerEvents: 'none'} : null}></label>
                                <img src={require('../../assets/icons/Steps_3.png')}  style={{ marwidth:"256px",height:"32px",    marginLeft: '30px'}}/>                                </div>
                             <div>
                            
                            
                             </div>
                             <div className={'export-close-icon'}> <img src={require('../../assets/icons/close-black.png')} style={{cursor:'pointer'}} onClick={closeExportPopUp} /></div>
                         </div>
                     </div>
                     <div className={'export-data-content'}>
                        {errMsg ? <ErrorMessage message={errMsg} title={msgTitle} visible={ShowErrPopUp} show={errPopUp} msgType={errMsgType} /> : null}
                        <div className={'interval-container'}>
                        <div className={'interval-title'} >File type</div>
                        <div>
                            <FormControl component="fieldset" className={'direction_option'} >
                                <div className={classes.intervalOptionBlock}>
                                    <StyledCheckbox
                                    checked={csvExport}
                                    color="primary"
                                    value='CSV'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={(e) => { exportToCsv(e) }}
                                    />
                                    <label>CSV</label>
                                </div> 
                                <div className={classes.intervalOptionBlock}>
                                    <StyledCheckbox
                                    checked={pdfExport}
                                    color="primary"
                                    value='PDF'
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    onChange={(e) => { exportToCsv(e) }}
                                    />
                                    <label>PDF</label>
                                </div>
                            </FormControl>
                        </div>
                        </div>
                    </div>
                    <div className={'export-data-footer'} style={{marginTop: '26px', justifyContent:'flex-end'}}>
                        <div>
                            <Button type='button' id='exportBact_btn' 
                                className={'txt-gray-700 cancel-btn font-14 '}  
                                style={{ width: '57px', height:'34px' }} 
                                onClick={backSteep3} type='button'
                                disabled={ exportStatus }
                            >
                                    Back
                            </Button>
                            <Button id='exportData_btn' 
                                className={'txt-gray-white blue-btn font-14'} 
                                style={{ width: '69px', height:'34px' }} 
                                type='button' onClick={exportFile}
                                disabled={ !exportStatus && getExportRequest.length > 0  && (csvExport || pdfExport) ? false : true}
                            >
                                    {
                                        exportStatus ?
                                        <CircularProgress />
                                        :
                                        "Export"
                                    }
                            </Button> 
                        </div>
                    </div>
                 </div>
            :null
            } 
            </div>
        </React.Fragment >
    )
}
export default ExportData;
//End ExportData component code ...
